import {
  CHANGE_MESSAGE_LAST_VISITED,
  FETCH_COURSES,
  SET_MESSAGES,
} from "./pwaDataTypes";
import app from "../../axiosConfig";
import { addToastMsg } from "../auth/authActions";

export const fetchCourses = (id) => {
  return async (dispatch) => {
    try {
      const { data } = await app.get(`/pwa/fetch-courses/${id}`);
      dispatch({
        type: FETCH_COURSES,
        payload: data,
      });
    } catch (error) {
      dispatch(addToastMsg(error?.response?.data?.message, "error"));
    }
  };
};

export const changeMessageLastVisitedAction = (
  changeMessageLastVisited,
  body
) => {
  return async (dispatch) => {
    try {
      const { data } = await changeMessageLastVisited(body);
      dispatch({
        type: CHANGE_MESSAGE_LAST_VISITED,
        payload: data?.changeMessageLastVisited,
      });
    } catch (error) {
      dispatch(addToastMsg(error?.response?.data?.message, "error"));
    }
  };
};

export const setMessages = (messages) => {
  return {
    type: SET_MESSAGES,
    payload: messages,
  };
};
